<template>
	<div class="employee-card" :style="cardColors">
		<b-avatar class="employee-image" variant="secondary" :text="initials"></b-avatar>
		<div class="card-details">
			<div class="title">
				<span>{{ fullName }}</span>
				<tag
					v-for="tag in tagListApi"
					:key="`tag-${tag.id}`"
					:id="tag.id"
					:color="tag.color"
					:title="tag.title"
				></tag>
			</div>
			<p class="subtitle">{{ workedHours }}/{{ weeklyHours }} hours assigned</p>
			<div class="options">
				<div class="reasons">
					<reason
						v-for="(reason, index) in reasonListApi"
						:key="index"
						:title="reason.title"
						:color="reason.status"
						:index="index"
					/>
				</div>
				<button @click="hanleAssignShiftClick">
					<slot name="actionButtor">
						Assign Shift
					</slot>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import tag from './tag';
import reason from './reason';
import { reasonList, tagList } from '../api';
export default {
	name: 'employee',
	props: {
		id: { required: true, type: Number },
		fullName: { required: true, type: String },
		// image: { required: false, type: String },

		// the total amount of hours that someone worked in current week
		workedHours: { required: false, type: String, default: () => this.workedHours || '-' },
		// the total amount of hours that someone can work in one week
		weeklyHours: { required: false, type: Number, default: 40 },
		// the list of reasons of why the system choose this employee
		reasonList: { required: false, type: Array },
		// the list of tags of why the system choose this employee
		tagList: { required: false, type: Array },
		// color of the corresponding employee status
		statusColor: { required: true, type: String },
		initials: { required: false, type: String },
		index: { required: true, type: Number },
	},
	components: { tag, reason },
	data() {
		return {
			reasonListApi: [...reasonList],
			tagListApi: [...tagList],
		};
	},
	mounted() {
		console.log('employee mounted with id', this.id);
		// foreach reasonList item get the corresponding object from reasonListApi
		this.reasonListApi = this.reasonList.map(reasonId => {
			return reasonList.find(reason => reason.id === reasonId);
		});
		this.tagListApi = this.tagList.map(tagId => {
			return tagList.find(tag => tag.id === tagId);
		});
	},
	computed: {
		// css variable object for dynamic colors
		cardColors() {
			return {
				'--statusColor': this.statusColor,
			};
		},
	},
	methods: {
		// emits an event to parent with employee id
		hanleAssignShiftClick() {
			this.$emit('assignShift', this.id);
		},
	},
};
</script>

<style lang="scss" scoped>
.employee-card {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 8px 0;
	padding: 10px 10px 10px 0;
	border-radius: 3px;
	box-shadow: 0 0 10px 0 #e3e3e3;
	background-color: #ffffff;

	.employee-image {
		margin-left: 15px !important;
		width: 4rem !important;
		height: 3rem !important;
		font-size: 1.3em !important;
		background-color: #e0e0e0 !important;
		color: #616e84 !important;
	}

	&::before {
		content: '';
		position: absolute;
		width: 6px;
		height: 100%;
		border-radius: 3px;
		background-color: var(--statusColor);
	}

	.profile-img {
		width: 37.1px;
		height: 37.9px;
		margin-left: 10px;
		object-fit: contain;
		border-radius: 50%;
	}

	.card-details {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		width: 100%;
		margin-left: 10px;

		.title {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: 8px;
			font-size: 14px;
			color: #646464;

			span {
				margin-right: 10px;
			}
		}
		.subtitle {
			font-size: 11px;
			color: #646464;
			margin-bottom: 0;
		}
		.options {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			font-size: 9px;

			.reasons {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				justify-self: flex-start;
			}

			button {
				width: 90px;
				height: 27px;
				border-radius: 3px;
				font-size: 9px;
				background-color: #517fa8;
				color: #fff;

				&:focus {
					outline: none;
				}
			}
		}
	}
}
</style>
